<template>
  <div class="playVideo">
    <div v-if="this.$store.state.webNavigator=='pc'">
      <div class="modal">
        <div class="modal-dialog">
          <div class="icon-pc-3 locate" @click="close()"></div>
          <div>
            <div class="video-name">
              <p>{{videoTlt}}</p>
              <video id="vidPc" class="playVideo-player" :src="videoPlay" controls="controls" width="975px" autostart=false
                     loop=false></video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.$store.state.webNavigator=='phone'">
      <div class="modal">
        <div class="phoneVideo-Dialog">
          <div class="">
            <p class="displayIB phoneVideo-name font24phone">{{videoTlt}}</p>
            <div class="positionAB phoneVideo-close" @click="close()">
            </div>
            <video id="vidPe" class="phoneVideo-Play positionAB" :src="videoPlay" controls="controls" width="975px"
                                                             autostart=false loop=false></video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'playVideo',
  props: {
    videoPlay: {
      type: String,
      default: '',
    },
    videoTlt: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      active: '0',
      msg: false,
    };
  },
  methods: {
    Cactive (index) {
      this.active = index;
    },
    close () {
      let video = this.$store.state.webNavigator == 'pc' ? document.getElementById('vidPc') : document.getElementById('vidPe');
      // console.log(video);
      if (video.paused) { // 如果已暂停则播放
        // video.play(); //播放控制
      } else { // 已播放点击则暂停
        video.pause(); // 暂停控制
      }
      // $('#vid')[0].pause();
      this.$emit('funcVideo', this.msg);
    },
  },
  created () {
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url('playVideoPhone');
  }

  @media screen and (min-width: 800px) {
    @import url('playVideo');
  }

</style>



// WEBPACK FOOTER //
// playVideo.vue